import _ from 'lodash'
import type {ComponentExportStructure, CoreExportFormat} from '@wix/document-services-types'
import type {DecorationPluginFunction} from '../../types'
import {COMPONENT_PROPERTIES_MAPPING} from './constants'

const packSingleComponent = (component: ComponentExportStructure): ComponentExportStructure => {
    const newComponent: ComponentExportStructure = {}

    for (const {from, to} of COMPONENT_PROPERTIES_MAPPING) {
        const value = _.get(component, from)
        if (value !== undefined) {
            _.set(newComponent, to, value)
        }
    }

    return newComponent
}

// This plugin is used to pack the component export structure into a serdes structure
// meaning properties from component export being mapped with serdes expectations
export const pack: DecorationPluginFunction = (componentExport: CoreExportFormat) => {
    const newComponents: Record<string, ComponentExportStructure> = {}

    _.forOwn(componentExport.components, component => {
        const newComponent = packSingleComponent(component)
        newComponents[newComponent.semanticId] = newComponent
    })

    componentExport.components = newComponents
}
